import {Accordion as AccordionBase} from './Accordion'
import {AccordionDetails} from './AccordionDetails'
import {AccordionSummary} from './AccordionSummary'

export const Accordion = Object.assign(AccordionBase, {
  Details: AccordionDetails,
  Summary: AccordionSummary,
})
